import React from 'react';
import CustomerSupportComponent from '../../../Components/Support/CustomerSupport';

export default function CustomerSupport() {
    return (
        <div className='page-body'>
            <CustomerSupportComponent />
        </div>
    );
}